import React from "react";
import { Link, useLocation } from "react-router-dom";
import { translations } from "../translations";

const LegalPage = () => {
  const location = useLocation();
  const currentLang = location.pathname.split("/")[1] || "fr";
  const t = translations[currentLang];

  return (
    <div className="min-h-screen py-12 px-4 md:px-12 text-white">
      <div className="max-w-4xl mx-auto bg-light text-dark rounded-2xl overflow-hidden shadow-2xl p-8 space-y-8">
        <h1 className="text-3xl font-bold text-orange border-b pb-2">{t.legalPage.title}</h1>

        <section>
          <h2 className="text-xl font-semibold text-orange mb-2">{t.legalPage.editorTitle}</h2>
          <p className="text-gray-800 leading-relaxed" style={{ whiteSpace: 'pre-line' }}>
            {t.legalPage.editorContent}
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-orange mb-2">{t.legalPage.hostingTitle}</h2>
          <p className="text-gray-800 leading-relaxed" style={{ whiteSpace: 'pre-line' }}>
            {t.legalPage.hostingContent}
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-orange mb-2">{t.legalPage.intellectualPropertyTitle}</h2>
          <p className="text-gray-800 leading-relaxed">
            {t.legalPage.intellectualPropertyContent}
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-orange mb-2">{t.legalPage.liabilityTitle}</h2>
          <p className="text-gray-800 leading-relaxed">
            {t.legalPage.liabilityContent}
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-orange mb-2">{t.legalPage.personalDataTitle}</h2>
          <p className="text-gray-800 leading-relaxed">
            {t.legalPage.personalDataContent}
            <Link to={`/${currentLang}/privacy-policy`} className="text-green hover:text-hovgreen underline">
              {t.legalPage.privacyPolicyLink}
            </Link>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default LegalPage;
